<div class="d-flex justify-content-center align-items-center min-vh-100 bg-light">
  <div class="container" style="max-width: 400px;">
    
    <app-card title="Forgot Password">
      <div class="mb-2 text-center">
        <div  [ngClass]="{'logo': isProd, 'logo-training': !isProd && !isStaging, 'logo-staging': !isProd && isStaging}" ></div>
      </div>
      <div class="mb-3">
        <label class="form-label">Email Address</label>
        <input type="email" 
               class="form-control" 
               [(ngModel)]="emailAddress" 
               placeholder="Email Address">
      </div>

      <div class="d-flex justify-content-end">
        <button *ngIf="!sendingReset" 
                type="button" 
                class="btn btn-success" 
                (click)="resetPassword()">
          Reset Password
        </button>

        <button *ngIf="sendingReset" 
                type="button" 
                class="btn btn-success" 
                disabled>
          <span class="spinner-border spinner-border-sm me-2"></span>
          Sending...
        </button>
      </div>
    </app-card>

  </div>
</div>